import Header from '../../../__Layout/Header';
import React from "react";
import PaidCourseComp from './PaidCourseComp';
import FreeCourseComp from './FreeCourseComp';
export default function Index() {    

     
    return (
            <div className="vehicleCategories">
            <Header />
            <main id="main" className="main">
            <div className="card">
                <div className="card-body">
                    <h5 className="card-title">My Courses/Training</h5>
                    <ul className="nav nav-tabs nav-tabs-bordered d-flex" id="borderedTabJustified" role="tablist">
                       <li className="nav-item flex-fill" role="presentation">
                        <button className="nav-link w-100 active" id="home-tab" data-bs-toggle="tab" data-bs-target="#bordered-justified-home" type="button" role="tab" aria-controls="home" aria-selected="true">My Courses/Training</button>
                        </li>
                    </ul>
                    <div className="tab-content pt-2" id="borderedTabJustifiedContent">
                        <div className="tab-pane fade show active" id="bordered-justified-home" role="tabpanel" aria-labelledby="home-tab"> 
                            <section className="section">
                                <div className="row">
                                        <PaidCourseComp />
                                       
                                        <FreeCourseComp />
                                  
                                </div>
                            </section>  
                        </div>
                    </div>
                </div>
            </div>
            </main>
        </div>
    );
}
